import type { SamplesFilters } from "@services/samples/list/type";
import { defaultFilters } from "@typings/entities/samples/filter";
import { useFilters } from "./useFilters";

export function useSamplesFilters(defaults: SamplesFilters = defaultFilters) {
  return useFilters<SamplesFilters>({
    defaults,
  });
}
